module.exports = __WEBPACK_EXTERNAL_MODULE_370__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 370
// module chunks = 0